import { useFormik } from 'formik';
import { useState } from 'react'
import { Col, Form, Modal, Row } from 'react-bootstrap';
import * as Yup from "yup";
import Autocomplete from '../../../components/input/autocomplete';
import "../../profile.scss"
import { INIT_INPUT_SEARCH, TYPE } from '../../../constants/moduleConsts';
import TextValidator from '../../../components/input/text-validator';
import { heightSelectMutil } from '../../../components/input/autocomplete/styleJS';
import { GroupButton } from '../../../components/GroupButton';
import useMultiLanguage from '../../../../hook/useMultiLanguage';
import { IItemSearch } from '../../../models/models';
import { KTSVG } from '../../../../../_metronic/helpers';

type Props = {
  open: boolean
  handleSearch: (listInputSearch: IItemSearch[]) => void;
  handleClose: () => void;
  listInputSearch: IItemSearch[],
  listOption: any[],
}

const AdvancedSearch = (props: Props) => {
  const { open, handleSearch, handleClose, listOption } = props;

  const { lang } = useMultiLanguage();
  const [listOptionRemove, setListOptionRemove] = useState<IItemSearch[]>([]);
  const [listInputSearch, setListInputSearch] = useState<IItemSearch[]>(() => {
    let data = props?.listInputSearch.filter((item: IItemSearch) => item?.value)
    if (data?.length > 0) {
      return [...data]
    } else {
      return [INIT_INPUT_SEARCH]
    }
  })

  const validationSchema = Yup.object().shape({})

  const handleSubmit = () => {
    listOption.forEach((item: any) => {
      let itemData = listInputSearch.find((itemSearch: IItemSearch) => itemSearch?.field === item?.field)
      item.value = itemData?.value || null
    })
    handleSearch(listOption)
  }

  const formik = useFormik({
    initialValues: {},
    validationSchema,
    onSubmit: handleSubmit
  })

  const listTobe = [
    { type: TYPE.SELECT, name: "Bằng" },
    { type: TYPE.DATE, name: "Bằng" },
    { type: TYPE.STATUS, name: "Là" },
    { type: TYPE.TEXT, name: "Chứa" },
  ]

  const handleAddField = () => {
    const checkAdd = listInputSearch.every((inputSearch: any) => inputSearch?.value)

    if (checkAdd) {
      const newlist: IItemSearch[] = [...listInputSearch]
      newlist.push(INIT_INPUT_SEARCH)
      setListInputSearch(newlist)
    }
  }

  const handleSelectField = (value: any, index: number) => {
    const newList: IItemSearch[] = [...listInputSearch]
    if (value) {
      setListOptionRemove(preList => [...preList.filter(item => item.field !== newList[index]?.field), value]);
    } else {
      setListOptionRemove(preList => preList.filter(item => item.field !== listInputSearch[index]?.field));
    }
    newList[index] = value
    setListInputSearch(newList.length > 1 ? newList.filter(item => item) : newList);
  }

  const handleSelect = (value: any, index: number) => {
    const newlist: IItemSearch[] = [...listInputSearch]
    newlist[index].value = value
    setListInputSearch(newlist)
  }

  const handleChange = (e: any, index: number) => {
    const newlist: IItemSearch[] = [...listInputSearch]
    newlist[index].value = e.target.value
    setListInputSearch(newlist)
  }

  const handleDelete = (index: number) => {
    if (listInputSearch?.length === 1) {
      return;
    }
    const newlist: IItemSearch[] = [...listInputSearch]
    setListOptionRemove(preList => preList.filter(item => item.field !== listInputSearch[index]?.field));
    newlist.splice(index, 1)
    setListInputSearch(newlist)
  }

  const checkISTobe = (type: string) => {
    let tobe = listTobe.find((itemTobe: any) => itemTobe.type === type)
    return tobe?.name ? tobe?.name : listTobe[3].name
  }

  return (
    <Form onSubmit={formik.handleSubmit}>
      <Modal
        show={open}
        size="lg"
        centered
        aria-labelledby="example-custom-modal-styling-title"
        onHide={handleClose}
        backdrop="static"
      >
        <Modal.Header closeButton className="spaces px-16 py-10">
          <Modal.Title
            id="example-custom-modal-styling-title"
            className='spaces fs-16 fw-700'
          >
            <b>Tìm kiếm nâng cao</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className='spaces p-16'>
          <div className='advancedSearch'>
            {
              listInputSearch.map((inputSearch: any, index: number) => {
                return (
                  <Row className='spaces mb-16'>
                    <Col className={`${inputSearch?.isMulti ? "flex-start" :"flex-middle"}`}>
                      <div className='flex-1'>
                        <Autocomplete
                          className='w-100'
                          options={listOption}
                          removeOption={listOptionRemove}
                          keyRemoveOption="field"
                          value={inputSearch?.field ? inputSearch : null}
                          onChange={((value) => handleSelectField(value, index))}
                        />
                      </div>
                      <div className='verb'>{checkISTobe(inputSearch?.type)}</div>

                      <div className='flex flex-1 flex-middle'>
                        {
                          (inputSearch?.type === TYPE.SELECT ||
                            inputSearch?.type === TYPE.STATUS) &&
                          <div className='flex-1'>
                            <Autocomplete
                              className='w-100'
                              value={inputSearch?.value || (inputSearch?.isMulti ? [] : "") }
                              options={inputSearch?.listOption || []}
                              searchFunction={inputSearch?.searchFunction || undefined}
                              onChange={((value) => handleSelect(value, index))}
                              searchObject={(inputSearch?.searchFunction && inputSearch?.searchObject) ? inputSearch?.searchObject : {}}
                              dependencies={[inputSearch]}
                              isReadOnly={!inputSearch?.field ? true : undefined}
                              isMulti={inputSearch?.isMulti}
                              closeMenuOnSelect={!inputSearch?.isMulti}
                              getOptionValue={(option) => inputSearch?.optionLabel ? option?.[inputSearch?.optionLabel] : option?.name}
                              getOptionLabel={(option) => inputSearch?.optionLabel ? option?.[inputSearch?.optionLabel] : option?.name}
                              styles={inputSearch?.isMulti && heightSelectMutil("auto", "64px")}
                            />
                          </div>
                        }
  
                        {
                          (inputSearch?.type === TYPE.TEXT ||
                            inputSearch?.type === TYPE.DATE ||
                            !inputSearch?.type
                          ) &&
                          <TextValidator
                            className='flex-1'
                            name={inputSearch?.field || ""}
                            value={inputSearch?.value || ""}
                            type={inputSearch?.type || TYPE.TEXT}
                            placeholder="Nhập giá trị tìm kiếm"
                            onChange={(e: any) => handleChange(e, index)}
                            readOnly={!inputSearch?.field}
                          />
                        }
                        <div className="spaces ml-10 cursor-pointer" onClick={() => handleDelete(index)}>
                          <KTSVG
                            className="color-red"
                            path="/media/icons/trash.svg"
                            svgClassName='spaces w-18 h-18'
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                )
              })
            }

            <div className='flex addField'>
              <p
                className='spaces pr-24'
                onClick={() => setListInputSearch([INIT_INPUT_SEARCH])}
              >
                Làm mới
              </p>
              <p onClick={handleAddField}>Thêm trường</p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="flex-center spaces px-16 py-10">
          <GroupButton handleEvent={handleSubmit}>
            {lang("BTN.SEARCH")}
          </GroupButton>
        </Modal.Footer>
      </Modal>
    </Form>
  )
}

export default AdvancedSearch;